// document.addEventListener('mouseover', e => {
//     const isDropdownButton = e.target.matches('[data-dropdown-button]');
//     if (!isDropdownButton && e.target.closest('[data-dropdown]') != null) return;

//     let currentDropdown;
//     if (isDropdownButton) {
//         currentDropdown = e.target.closest('[data-dropdown]');
//         currentDropdown.classList.add('active');
//     }
    
//     document.querySelectorAll('[data-dropdown].active').forEach(dropdown => {
//         if (dropdown === currentDropdown) return;
//         dropdown.classList.remove('active');
//     })
// });

(function ($) {$(function(){
    $siteLinks = $('.site-links li a')
    $siteLinks.on('click', function(e) {
        $siteLinks.parent().removeClass('active');
    })
});}(_jQ3));